<script lang="ts">
	import { onMount, type Component } from 'svelte'
	import { LoadingAnimation } from '../types/enums'
	import { displayLoadingAnimation, manualAnimationPending } from '../stores'
	import MmLoadingAnimation from '../animations/MmLoadingAnimation.svelte'

	export let showOnMount: boolean = true
	let component: Component | undefined = undefined
	let show = false
	let animationProps: Record<string, unknown> | undefined

	type LazyLoader = () => Promise<{ default: Component }>

	const lottieLoaders: Partial<Record<LoadingAnimation, LazyLoader>> = {
		[LoadingAnimation.FileUpload]: () => import('../animations/FileUploadAnimation.svelte'),
		[LoadingAnimation.AiUpload]: () => import('../animations/AiUploadAnimation.svelte')
	}

	async function getComponentForType(type: LoadingAnimation): Promise<Component> {
		const loader = lottieLoaders[type]
		if (loader) {
			const module = await loader()
			return module.default
		}
		return MmLoadingAnimation
	}

	/*this shows the MmLoadingAnimation on start of every refresh of every Page, were LoadingAnimations is included */
	onMount(() => {
		component = MmLoadingAnimation
		if (showOnMount) {
			show = true
			setTimeout(() => {
				if (!$manualAnimationPending) {
					// only end the animation, when there is no condition we are waiting for
					show = false
				}
			}, 2300)
		}
	})

	displayLoadingAnimation.subscribe(async (state) => {
		if (state.display === true) {
			component = await getComponentForType(state.animation)
			animationProps = state.animationProps
			show = true
		} else {
			show = false
		}
	})
</script>

{#if show}
	<svelte:component this={component} {...animationProps} />
{/if}
